import imgEmptyNoData from 'assets/images/img_emptyview_no_data.png';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import AppColors from 'general/constants/AppColors';
import UIHelper from 'general/helpers/UIHelper';
import useOnClickOutside from 'hooks/useOnClickOutside';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import EmptyView from '../EmptyView';

InputSearchDropdown.propTypes = {
  inputName: PropTypes.string.isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  items: PropTypes.array,
  onSelectedValueChanged: PropTypes.func,
  onSubmitSearch: PropTypes.func,
  disabled: PropTypes.bool,
  enableCheckValid: PropTypes.bool,
  isTouched: PropTypes.bool,
  isValid: PropTypes.bool,
  feedbackText: PropTypes.string,
  onBlur: PropTypes.func,
  placeholder: PropTypes.string,
};

function InputSearchDropdown(props) {
  // ---- params ----
  const {
    inputName,
    items,
    selectedValue,
    onSelectedValueChanged,
    onSubmitSearch,
    disabled,
    selectedText,
    enableCheckValid,
    isTouched,
    isValid,
    feedbackText,
    onBlur,
    placeholder,
  } = props;
  const [showDropdown, setShowDropdown] = useState(false);
  const ref = useRef();
  useOnClickOutside(ref, () => {
    if (showDropdown) {
      setShowDropdown(false);
    }
  });

  // ---- methods ----
  const buildItem = (title, subTitle, isChecked = false, onPressed) => {
    return (
      <div
        className="d-flex align-items-center justify-content-between px-4 py-3 bg-hover-success"
        onClick={onPressed}
        style={{
          borderBottom: `1px solid ${AppColors.gray[200]}`,
          backgroundColor: isChecked ? AppColors.primary : 'transparent',
        }}
      >
        <div className="d-flex flex-column cursor-pointer">
          <span
            style={UIHelper.buildFontStyle(
              '400',
              '13px',
              isChecked ? 'white' : AppColors.gray[800]
            )}
          >
            {title}
          </span>
          <span
            style={UIHelper.buildFontStyle(
              '400',
              '12px',
              isChecked ? 'white' : AppColors.gray[600]
            )}
          >
            {subTitle}
          </span>
        </div>
      </div>
    );
  };

  return (
    <div className="position-relative" ref={ref}>
      <KTFormSearch
        name={inputName}
        placeholder={placeholder?.length ? placeholder : "Nhập để tìm kiếm..."}
        onSubmit={(value) => {
          if (onSubmitSearch) {
            onSubmitSearch(value);
          }
        }}
        onFocus={() => {
          if (!showDropdown) {
            setShowDropdown(true);
          }
        }}
        onBlur={() => {
          // setShowDropdown(false);
          if (onBlur) {
            onBlur();
          }
        }}
        disabled={disabled ?? false}
        value={selectedText}
        enableCheckValid={enableCheckValid}
        isTouched={isTouched}
        isValid={isValid}
        feedbackText={feedbackText}
      />

      {/* dropdown content */}
      {showDropdown && (
        <div
          className="position-absolute py-2 bg-white shadow w-100 overflow-auto"
          style={{
            zIndex: '9999',
            border: `1px solid ${AppColors.gray[300]}`,
            borderRadius: '5px',
            maxHeight: '320px',
          }}
        >
          {items?.length > 0 ? (
            <>
              {items?.map((item, index) => {
                return (
                  <div key={item?.value ?? index}>
                    {buildItem(item?.title, item?.subTitle, item?.value === selectedValue, () => {
                      if (onSelectedValueChanged) {
                        onSelectedValueChanged(item?.value);
                        setShowDropdown(false);
                      }
                    })}
                  </div>
                );
              })}
            </>
          ) : (
            <div>
              <EmptyView
                icon={imgEmptyNoData}
                title="Không có dữ liệu để hiển thị"
                text={<span>Hiện không có dữ liệu để hiển thị.</span>}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default InputSearchDropdown;
